const HOUR = 1000 * 60 * 60
const DAY = HOUR*24
const MONTH = DAY*30
const YEAR = MONTH*12
const map = new Map<string,boolean>()

let combos = {
    buyFutBuyPut:"buyFutBuyPut",
    buyCallSellFut:"buyCallSellFut",
    buyCallBuyPut:"buyCallBuyPut",
    sellPutBuyPut:"sellPutBuyPut",
    buyCallSellCall:"buyCallSellCall",
    buyFutSellCall:"buyFutSellCall",
    sellPutSellFut:"sellPutSellFut",
    sellPutSellCall:"sellPutSellCall",
}
let comboTypes = [combos.buyFutBuyPut, combos.buyCallSellFut, combos.buyCallBuyPut, combos.sellPutBuyPut, combos.buyCallSellCall, combos.buyFutSellCall, combos.sellPutSellFut]
export default{
    SETTLEMENT_CHARGES: (0.12 + 0.25) / 100,
    NET_OFF_CHARGES: (0.12 + 0.25) / 100,
    MODE_NORMAL: "nrml",
    MODE_LAST_PRICE: "lastP",
    DAY: HOUR * 24,
    WEEK: DAY * 7,
    MONTH: DAY * 40,
    YEAR: YEAR,
    ComboType: combos,
    comboTypes : comboTypes,
    deepComboTypes : ["buyFut", "sellFut"],
    noBrainerComboTypes : [combos.buyCallSellCall, combos.sellPutBuyPut],
    futureComboTypes : [combos.buyCallSellFut, combos.buyFutBuyPut],
    deepSellComboTypes : [combos.buyFutSellCall, combos.sellPutSellFut, combos.sellPutSellCall],
    sorterMap: map, CE: "CE", PE: "PE", FUT:"FUT",
    CLIENTS: [
        "ECA007",
        "JHJ926",
        "UUR152",
        "ICT895",
        "RHN536",
        "RHN1310_U",
        "RHN1309_U",
    ],
    EXCHANGES: ["MCX", "NCDEX", "NFO", "NCO"]
}
